import { render, staticRenderFns } from "./langMessage.vue?vue&type=template&id=b56657c4"
import script from "./langMessage.vue?vue&type=script&lang=js"
export * from "./langMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56657c4')) {
      api.createRecord('b56657c4', component.options)
    } else {
      api.reload('b56657c4', component.options)
    }
    module.hot.accept("./langMessage.vue?vue&type=template&id=b56657c4", function () {
      api.rerender('b56657c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/lang/langMessage.vue"
export default component.exports